// Esignature MFE entry point
import { createApp } from 'vue';
import { setupApp } from '@Src/app/setupApp';
import { AppContext } from 'host/enums';
import { setMfeContext } from 'host/mfeBridge';
import type { Company, Brand } from '@Shared';
import App from './App.vue';
import { syncRouterToHost } from '@Router/syncRouterToHost';
import router from '@Router/index';
import { useCompanyStore } from '@Stores/company.store';

let app: ReturnType<typeof createApp> | null = null;
let containerId: string | null = null;

export const mount = async (appContainerId: string,  options?: {company: Company, brand?: Brand | null}) => {
    if (app) {
        console.warn('[Esignature MFE] App already exists. Forcing unmount...');
        app.unmount();
    }

    containerId = appContainerId;

    // TODO: Define your app context in host and then set it here
    // This lets the host know which MFE is currently active
    setMfeContext(AppContext.YourContext);

    app = createApp(App); 
    await setupApp(app);

    if (options?.company) {
       const companyStore = useCompanyStore();
       companyStore.setCompany(options.company);
       companyStore.setBrand(options.brand ?? null);
    }

    await syncRouterToHost(router);
    app.mount(containerId);
}

export const unmount = () => {
    if (!app) return;
    app.unmount();

    if (containerId) {
        const container = document.querySelector(containerId);
        if (container) container.innerHTML = '';
    }
    app = null;
}
